import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
} from '@mui/icons-material';
import {
  CertificateStatus,
  CERTIFICATE_STATUS_LABELS,
  CERTIFICATE_STATUS_COLORS,
} from '../../../types/certificate';

interface CertificateStatusChipProps {
  status: CertificateStatus;
  size?: 'small' | 'medium';
}

export const CertificateStatusChip: React.FC<CertificateStatusChipProps> = ({
  status,
  size = 'small',
}) => {
  const getIcon = () => {
    switch (status) {
      case CertificateStatus.VALID:
        return <CheckCircleIcon fontSize="small" />;
      case CertificateStatus.EXPIRING:
        return <WarningIcon fontSize="small" />;
      case CertificateStatus.EXPIRED:
        return <ErrorIcon fontSize="small" />;
      default:
        return undefined;
    }
  };

  return (
    <Tooltip title={CERTIFICATE_STATUS_LABELS[status]}>
      <Chip
        label={CERTIFICATE_STATUS_LABELS[status]}
        color={CERTIFICATE_STATUS_COLORS[status]}
        size={size}
        icon={getIcon()}
        sx={{
          fontWeight: 'medium',
          minWidth: size === 'small' ? 70 : 90,
        }}
      />
    </Tooltip>
  );
};

export default CertificateStatusChip;
